import { createConnectQueryKey } from '@connectrpc/connect-query'
import {
  getPlantUnit,
  listPlantUnits,
  updatePlantUnit,
} from '@ebalance/proto/bffuser/v1/occto_master_service-OcctoMasterService_connectquery'

import {
  type InvalidatingMutationResultFor,
  useInvalidatingMutation,
} from '~/hooks/useInvalidatingMutation'

/** 電源ユニットの更新 mutation (楽観ロック)。成功したら一覧を最新化する。 */
export function useUpdatePlantUnit(): InvalidatingMutationResultFor<
  typeof updatePlantUnit
> {
  return useInvalidatingMutation(updatePlantUnit, [
    createConnectQueryKey({
      schema: listPlantUnits,
      cardinality: 'finite',
    }),
    // 詳細ページは保存後の最新 (更新の記録と、次の編集の楽観ロックの基準) を取り直す
    createConnectQueryKey({
      schema: getPlantUnit,
      cardinality: 'finite',
    }),
  ])
}
